import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Nav, Tab } from "react-bootstrap";
import DataTable from "react-data-table-component";
//import { Link } from "react-router-dom";
import swal from "sweetalert";
import { getList } from "../../../services/SubRecruiterService";
import axiosInstance from "../../../services/AxiosInstance";
import { useSearchParams } from "react-router-dom";
import {
  getJobFairOption,
  getMatchedCandidate,
  sendEventEmail,
  updateVerificationSatus,
} from "../../../services/JobFairService";
import { downloadCSV } from "../../../helpers/dataTableHelper";
import SearchInputComponent from "./Common/SearchInputComponent";
import { useSelector } from "react-redux";

export default function JobFairVarification() {
  const [searchParams, setSearchParams] = useSearchParams();
  const fid = searchParams.get("fid");

  const { download_access, roleName } = useSelector(
    (state) => state?.auth?.auth
  );

  const [jobFair, setJobFair] = useState([]);
  const [fairCount, setFairCount] = useState({
    active: 0,
    inactive: 0,
    total: 0,
  });

  const [isClear, setIsClear] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [selectedRow, setSelectedRows] = useState([]);
  const [fetch, setFetch] = useState(false);
  const [reqParams, setReqParams] = useState({
    page: currentPage,
    limit: perPage,
    sort_by: "created_at",
    sort_direction: "DESC",
    status: "",
    fid: fid ? fid : "",
    keyword: "",
  });

  const [isCandidate, setIsCandidate] = useState(true);

  const [cdata, setcData] = useState([]);
  const [cloading, setcLoading] = useState(false);
  const [ctotalRows, setcTotalRows] = useState(0);
  const [cperPage, setcPerPage] = useState(10);
  const [ccurrentPage, setcCurrentPage] = useState(1);
  const [ctoggleCleared, setcToggleCleared] = useState(false);
  const [cselectedRow, setcSelectedRows] = useState([]);
  const [cfetch, setcFetch] = useState(false);
  const [creqParams, setcReqParams] = useState({
    page: ccurrentPage,
    limit: cperPage,
    sort_by: "created_at",
    sort_direction: "DESC",
    status: "",
    event_id: fid ? fid : "",
    keyword: "",
  });

  const updateStatus = useCallback(
    (event_id, candidate_id, call_status, accepted_status) => {
      if (call_status !== "" || accepted_status !== "") {
        updateVerificationSatus({
          event_id,
          candidate_id,
          call_status,
          accepted_status,
        }).then((res) => {
          setFetch(true);
        });
      } else {
        swal("Error", "Please select status.", "error");
      }
    },
    [setFetch]
  );

  const handleSendEmail = useCallback(
    (list = false, candidate_id = "", event_id = "") => {
      console.log(list, candidate_id, event_id, cselectedRow);

      const candidate = list
        ? [candidate_id]
        : cselectedRow.map((c, i) => c.id);

      if (candidate?.length < 1) {
        swal(
          "Opps",
          `Please select at least 1 candidate to send email.`,
          "error"
        );
        return false;
      }

      if (candidate?.length > 20) {
        swal("Opps", `Select at most 20 candidates to send email.`, "error");
        return false;
      }

      sendEventEmail({
        event_id: list ? event_id : creqParams.event_id,
        candidate_ids: candidate,
      })
        .then((resp) => {
          if (resp?.data.code === "success") {
            swal("Great Job!", resp?.data.message, "success");
            if (!list) {
              setcToggleCleared(!ctoggleCleared);
              setcSelectedRows([]);
              setcFetch(true);
            }
          } else if (resp?.data.code === "error") {
            if (!list) {
              setcToggleCleared(!ctoggleCleared);
            }
            swal("Opps", resp?.data.message, "error");
          }
        })
        .catch((error) => {
          if (!list) {
            setcToggleCleared(!toggleCleared);
          }
          swal("Opps", error?.response?.data?.message, "error");
        });
    },
    [cselectedRow, ctoggleCleared, setcFetch, setcToggleCleared]
  );

  const tableClm = useMemo(() => {
    return [
      {
        name: "Candidate ID",
        selector: (row) => row.candidate_id,
        sortable: true,
        sortField: "candidate_id",
      },
      {
        name: "Status",
        cell: (row) => {
          if (row?.status === 0) {
            return <span className="badge bg-danger">Rejected</span>;
          } else if (row?.status === 1) {
            return <span className="badge bg-success">Accepted</span>;
          } else {
            return <span className="badge bg-warning">Pending</span>;
          }
        },
        sortable: true,
        sortField: "status",
      },
      {
        name: "Job Fair title",
        selector: (row) => row.event_title,
        wrap: true,
        width: "200px",
        sortable: true,
        sortField: "event_title",
      },
      {
        name: "Candidate Name",
        selector: (row) => row.candidate_name,
        wrap: true,
        minwidth: "200px",
        sortable: true,
        sortField: "candidate_name",
      },
      {
        name: "Email",
        selector: (row) => row.email,
        wrap: true,
        minwidth: "200px",
        sortable: true,
        sortField: "email",
      },
      {
        name: "Phone",
        selector: (row) => row.phone_number,
        wrap: true,
        minwidth: "200px",
        sortable: true,
        sortField: "phone_number",
      },
      {
        name: "Datetime",
        selector: (row) => row.applied_date,
        wrap: true,
        minwidth: "200px",
        sortable: true,
        sortField: "applied_date",
      },
      {
        name: "Updated By",
        selector: (row) => row.updated_by,
        wrap: true,
        minwidth: "100px",
        //sortable: true,
        //sortField: "updated_by",
      },
      {
        name: "Email (resend only)",
        cell: (row) => {
          return (
            <button
              className="btn btn-sm btn-warning"
              onClick={() =>
                handleSendEmail(true, row.candidate_id, row.job_fair_id)
              }
            >
              <i className="fa fa-envelope"></i> Send Email
            </button>
          );
        },
        width: "140px",
      },
      {
        name: "Call Status",
        cell: (row) => {
          return (
            <select
              className="form-select"
              onChange={(e) =>
                updateStatus(
                  row.job_fair_id,
                  row.candidate_id,
                  e.target.value,
                  ""
                )
              }
              defaultValue={row?.call_status}
            >
              <option value="">Select Status</option>
              <option value={"Call 1 Pending"}>Call 1 Pending</option>
              <option value={"Call 2 Pending"}>Call 2 Pending</option>
              <option value={"Call 3 Pending"}>Call 3 Pending</option>
              <option value={"No Response"}>No Response</option>
              <option value={"On Hold"}>On Hold</option>
              <option value={"Email Confirmation"}>Email Confirmation</option>
              <option value={"WA Confirmation"}>WA Confirmation</option>
              <option value={"Confirmed - Attending"}>
                Confirmed - Attending
              </option>
            </select>
          );
        },
        width: "200px",
      },
      {
        name: "Reminder Status",
        omit: reqParams?.status === 1 ? false : true,
        cell: (row) => {
          return (
            <select
              className="form-select"
              onChange={(e) =>
                updateStatus(
                  row.job_fair_id,
                  row.candidate_id,
                  "",
                  e.target.value
                )
              }
              defaultValue={row?.accepted_status}
            >
              <option value="">Select Status</option>
              <option value={"Reminder 1 (7 days)"}>Reminder 1 (7 days)</option>
              <option value={"Reminder 2 (2 days)"}>Reminder 2 (2 days)</option>
              <option value={"Day of Event Reminder"}>
                Day of Event Reminder
              </option>
            </select>
          );
        },
        width: "200px",
      },
    ];
  }, [updateStatus, handleSendEmail, reqParams]);

  const [columns, setColumns] = useState(tableClm);

  const tablecClm = useMemo(() => {
    return [
      {
        name: "ID",
        selector: (row) => row.id,
        sortable: true,
        sortField: "id",
      },
      {
        name: "Email Status",
        cell: (row) => {
          if (row?.email_status !== null) {
            return <span className="badge bg-success">Sent</span>;
          } else {
            return <span className="badge bg-warning">Pending</span>;
          }
        },
        sortable: true,
        sortField: "email_status",
      },
      {
        name: "Candidate name",
        selector: (row) => row.legal_name,
        wrap: true,
        width: "200px",
        sortable: true,
        sortField: "legal_name",
      },
      {
        name: "Candidate email",
        selector: (row) => row.email,
        wrap: true,
        minwidth: "200px",
        sortable: true,
        sortField: "email",
      },
      {
        name: "Phone",
        selector: (row) => row.phone_number,
        wrap: true,
        minwidth: "200px",
        sortable: true,
        sortField: "phone_number",
      },
      {
        name: "Sent by",
        selector: (row) => row.sent_by,
        wrap: true,
        minwidth: "100px",
        //sortable: true,
        //sortField: "updated_by",
      },
    ];
  }, []);

  const [ccolumns, setcColumns] = useState(tablecClm);

  const jobFairList = useCallback(() => {
    getJobFairOption().then((res) => {
      setJobFair(res?.data?.data);
      if (creqParams?.event_id === "") {
        setcReqParams((pre) => ({ ...pre, event_id: res?.data?.data[0]?.id }));
        setReqParams({ ...reqParams, fid: res?.data?.data[0]?.id });
      }
      setcFetch(true);
    });
  }, []);

  const fetchUsers = useCallback(
    (params) => {
      setToggleCleared(true);
      setLoading(true);
      getList(params)
        .then((res) => {
          setIsClear(false);
          setData(res?.data?.data);
          setTotalRows(res?.data?.totalRecords);
          setLoading(false);
          setFetch(false);
          if (res.data.active !== undefined) {
            setFairCount({
              active: res?.data?.active,
              inactive: res?.data?.inactive,
              total: res?.data?.totalRecords,
            });
          }
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          setLoading(false);
          setFetch(false);
        });
    },
    [setFetch, setIsClear]
  );

  useEffect(() => {
    if (fetch) {
      fetchUsers(reqParams);
    }
  }, [fetch, reqParams, fetchUsers]);

  const fetchCandidate = useCallback(
    (params) => {
      setcToggleCleared(true);
      setcLoading(true);
      getMatchedCandidate(params)
        .then((res) => {
          setIsClear(false);
          setcData(res?.data?.data);
          setcTotalRows(res?.data?.total);
          setcLoading(false);
          setcFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          setcLoading(false);
          setcFetch(false);
        });
    },
    [setcFetch, setIsClear]
  );

  useEffect(() => {
    if (cfetch) {
      fetchCandidate(creqParams);
    }
  }, [cfetch, creqParams, fetchCandidate]);

  useEffect(() => {
    setColumns(tableClm);
  }, [reqParams?.status, setColumns, tableClm]);

  useEffect(() => {
    jobFairList();
  }, [jobFairList]);

  const handleDelete = useCallback(() => {
    const candidate = selectedRow.map((c, i) => {
      return c.job_fair_id;
    });

    if (candidate?.length < 1) {
      swal("Opps", "Please select at least 1 candidate to delete.", "error");
      return false;
    }

    axiosInstance
      .post("/admin/candidate/delete-job-fair-candidates", {
        candidateIds: candidate,
      })
      .then((resp) => {
        if (resp?.data.code === "success") {
          swal("Great Job!", resp?.data.message, "success");
          setToggleCleared(true);
          setFetch(true);
        } else if (resp?.data.code === "error") {
          setToggleCleared(true);
          swal("Opps", resp?.data.message, "error");
        }
      })
      .catch((error) => {
        setToggleCleared(true);
        swal("Opps", error?.response?.data?.message, "error");
      });
  }, [selectedRow, setFetch, setToggleCleared]);

  const handleAcceptReject = useCallback(
    (e, status) => {
      const candidate = selectedRow.map((c, i) => {
        return c.job_fair_id;
      });

      if (candidate?.length < 1) {
        e.target.value = "";
        swal(
          "Opps",
          `Please select at least 1 candidate to ${
            status === "1" ? "Accept" : "Reject"
          }.`,
          "error"
        );
        return false;
      }

      if (candidate?.length > 20) {
        e.target.value = "";
        swal("Opps", `Select at most 20 candidates to process.`, "error");
        return false;
      }

      let url = `/admin/candidate/${
        status === "1" ? "activate" : "deactivate"
      }-job-fair-candidates`;

      axiosInstance
        .post(url, {
          candidateIds: candidate,
        })
        .then((resp) => {
          if (resp?.data.code === "success") {
            e.target.value = "";
            swal("Great Job!", resp?.data.message, "success");
            setToggleCleared(!toggleCleared);
            setSelectedRows([]);
            setFetch(true);
          } else if (resp?.data.code === "error") {
            setToggleCleared(!toggleCleared);
            swal("Opps", resp?.data.message, "error");
          }
        })
        .catch((error) => {
          setToggleCleared(!toggleCleared);
          swal("Opps", error?.response?.data?.message, "error");
        });
    },
    [selectedRow, toggleCleared, setFetch, setToggleCleared]
  );

  const handlePageChange = useCallback(
    (page) => {
      if (isCandidate) {
        setcCurrentPage(page);
        setcReqParams({
          ...creqParams,
          page: page,
        });
        setcFetch(true);
      } else {
        setCurrentPage(page);
        setReqParams({
          ...reqParams,
          page: page,
        });
        setFetch(true);
      }
    },
    [
      setReqParams,
      reqParams,
      setFetch,
      setcReqParams,
      creqParams,
      setcFetch,
      isCandidate,
    ]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      if (isCandidate) {
        setcPerPage(newPerPage);
        setcReqParams({
          ...creqParams,
          limit: newPerPage,
        });
        setcFetch(true);
      } else {
        setPerPage(newPerPage);
        setReqParams({
          ...reqParams,
          limit: newPerPage,
        });
        setFetch(true);
      }
    },
    [
      setReqParams,
      reqParams,
      setFetch,
      setcReqParams,
      creqParams,
      setcFetch,
      isCandidate,
    ]
  );

  const handleTabSelect = useCallback(
    (key) => {
      setCurrentPage(1);
      if (key === "accepted") {
        setIsCandidate(false);
        setIsClear(true);
        setReqParams({
          ...reqParams,
          page: 1,
          status: 1,
          keyword: "",
        });
        setFetch(true);
      } else if (key === "rejected") {
        setIsCandidate(false);
        setIsClear(true);
        setReqParams({
          ...reqParams,
          page: 1,
          status: 0,
          keyword: "",
        });
        setFetch(true);
      } else if (key === "candidates") {
        setIsCandidate(true);
        setIsClear(true);
        setcReqParams({
          ...creqParams,
          page: 1,
          keyword: "",
        });
        setcFetch(true);
      } else {
        setIsCandidate(false);
        setIsClear(true);
        setReqParams({
          ...reqParams,
          page: 1,
          status: "",
          keyword: "",
        });
        setFetch(true);
      }
    },
    [setReqParams, reqParams, setFetch, setcFetch, setcReqParams, creqParams]
  );

  const handleSort = useCallback(
    (column, sortDirection) => {
      if (column?.sortField !== undefined) {
        if (isCandidate) {
          setcReqParams({
            ...creqParams,
            sort_by: column.sortField,
            sort_direction: sortDirection,
          });
          setcFetch(true);
        } else {
          setReqParams({
            ...reqParams,
            sort_by: column.sortField,
            sort_direction: sortDirection,
          });
          setFetch(true);
        }
      }
    },
    [
      reqParams,
      setReqParams,
      setFetch,
      creqParams,
      setcReqParams,
      setcFetch,
      isCandidate,
    ]
  );

  const handleSearchText = useCallback(
    (text, isClear = false) => {
      if (text || isClear) {
        console.log(text, isClear, isCandidate);
        setcReqParams((state) => {
          return { ...state, keyword: "", page: 1 };
        });
        setReqParams((state) => {
          return { ...state, keyword: "", page: 1 };
        });
        if (isCandidate) {
          setcReqParams((state) => {
            return { ...state, keyword: text, page: 1 };
          });
          setcFetch(true);
        } else {
          setReqParams((state) => {
            return { ...state, keyword: text, page: 1 };
          });
          setFetch(true);
        }
      }
    },
    [setReqParams, setFetch, setcReqParams, setcFetch, isCandidate]
  );

  return (
    <>
      <div className="d-flex align-items-center mb-4 flex-wrap">
        <select
          onChange={(e) => {
            setcReqParams({ ...creqParams, event_id: e.target.value });
            setReqParams({ ...reqParams, fid: e.target.value });
            if (isCandidate) {
              setcFetch(true);
            } else {
              setFetch(true);
            }
          }}
          className="btn btn-primary btn-sm"
          value={isCandidate ? creqParams?.event_id : reqParams?.fid}
        >
          <option value="">Select Job Fair</option>
          {jobFair.length > 0 &&
            jobFair.map((jf, i) => (
              <option value={jf.id} key={i}>
                {jf.title}
              </option>
            ))}
        </select>
      </div>
      <div className="card">
        <div className="card-body">
          <Tab.Container
            defaultActiveKey="candidates"
            onSelect={(e) => handleTabSelect(e)}
          >
            <Nav
              as="ul"
              variant="pills"
              className="nav  flex-row justify-content-around mt-3"
              role="tablist"
            >
              <Nav.Item as="li" className="fs-5">
                <Nav.Link
                  disabled={cfetch}
                  as="a"
                  eventKey="candidates"
                  to="#all"
                >
                  Tool Matching candidates (Auto)
                </Nav.Link>
              </Nav.Item>

              <Nav.Item as="li" className="fs-5">
                <Nav.Link as="a" eventKey="all" to="#all">
                  Registered candidates
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" className="fs-5">
                <Nav.Link as="a" eventKey="accepted" to="#all">
                  Accepted candidates
                </Nav.Link>
              </Nav.Item>
              <Nav.Item as="li" className="fs-5">
                <Nav.Link as="a" eventKey="rejected" to="#all">
                  Rejected candidates
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <hr className="my-3" />
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
              {!isCandidate ? (
                <div>
                  <select
                    onChange={(e) => handleAcceptReject(e, e.target.value)}
                    className="btn btn-warning btn-sm me-2"
                  >
                    <option value="">Status</option>
                    <option value={1}>Accept</option>
                    <option value={0}>Reject</option>
                  </select>

                  <button
                    onClick={handleDelete}
                    className="btn btn-danger me-2 btn-sm"
                  >
                    <i className="fas fa-trash me-1"></i> Delete
                  </button>

                  {download_access && (
                    <button
                      onClick={() =>
                        downloadCSV(data, "event-registration-list-")
                      }
                      className="btn btn-info btn-sm ms-5"
                    >
                      <i className="fas fa-file-csv ms-1"></i> Export
                    </button>
                  )}
                </div>
              ) : (
                <div>
                  <button
                    onClick={() => handleSendEmail()}
                    className="btn btn-warning me-2 btn-sm"
                  >
                    <i className="fas fa-envelope me-1"></i> Send Email
                  </button>
                </div>
              )}
              <div>
                <button
                  //onClick={() => downloadCSV(data, "event-registration-list-")}
                  className="btn btn-info btn-sm ms-2"
                >
                  {fairCount?.total} Records
                </button>
                <button
                  //onClick={() => downloadCSV(data, "event-registration-list-")}
                  className="btn btn-success btn-sm ms-2"
                >
                  {fairCount?.active} Accepted
                </button>
                <button
                  //onClick={() => downloadCSV(data, "event-registration-list-")}
                  className="btn btn-warning btn-sm ms-2"
                >
                  {fairCount?.inactive} Rejected
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <DataTable
                //className="table display dataTablesCard job-table table-responsive-xl card-table dataTable no-footer"
                columns={isCandidate ? ccolumns : columns}
                data={isCandidate ? cdata : data}
                progressPending={isCandidate ? cloading : loading}
                pagination
                paginationServer
                paginationTotalRows={isCandidate ? ctotalRows : totalRows}
                paginationDefaultPage={isCandidate ? ccurrentPage : currentPage}
                onChangeRowsPerPage={handlePerRowsChange}
                paginationRowsPerPageOptions={[
                  10, 20, 30, 50, 100, 200, 500, 1000, 1500, 2000,
                ]}
                onChangePage={handlePageChange}
                selectableRows
                persistTableHead
                onSelectedRowsChange={({ selectedRows }) => {
                  if (isCandidate) {
                    setcSelectedRows(selectedRows);
                  } else {
                    setSelectedRows(selectedRows);
                  }
                }}
                clearSelectedRows={isCandidate ? ctoggleCleared : toggleCleared}
                onSort={handleSort}
                sortServer
                fixedHeader={true}
                fixedHeaderScrollHeight={"500px"}
                subHeader
                subHeaderComponent={
                  <SearchInputComponent
                    setFilterText={handleSearchText}
                    removeText={isClear}
                  />
                }
              />
            </div>
          </Tab.Container>
        </div>
      </div>
    </>
  );
}
